
import { setState, state } from '../..';
import { SiteHome } from './home/homeView.interface';
import { SiteShell } from './shell/shellView.interface';
import { View } from '../..';
import { SiteDonation } from './donation/donationView.interface';

type SiteViews = {
    siteHome:View<SiteHome>;
    siteShell:View<SiteShell>;
    donation: View<SiteDonation>,
}

const defaultSiteViewsState: SiteViews = {
    siteHome:null,
    siteShell:null,
    donation:null
};

function updateSiteView(payload: Partial<SiteViews>, effect: string) {
  setState("VIEWS", { VIEWS: { ...state.VIEWS, ...payload } }, effect);
}

export { SiteViews, defaultSiteViewsState, updateSiteView };
